import { render, staticRenderFns } from "./MasterDataUnit.vue?vue&type=template&id=1e1897ab&scoped=true"
import script from "./MasterDataUnit.vue?vue&type=script&lang=js"
export * from "./MasterDataUnit.vue?vue&type=script&lang=js"
import style0 from "./MasterDataUnit.vue?vue&type=style&index=0&id=1e1897ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1897ab",
  null
  
)

export default component.exports